/**
 * Theme.js - La Shop à Cartes
 * Version nettoyée — sans doublons ni code mort
 */

// ============================================
// 1. COMPTE À REBOURS QUOTIDIEN
// ============================================
(function() {
  function updateDailyCountdown() {
    var elements = document.querySelectorAll('[data-daily-countdown]');
    if (elements.length === 0) return;

    var now = new Date();
    var midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    var diff = Math.max(0, midnight - now);

    var hours = Math.floor(diff / 3600000).toString().padStart(2, '0');
    var minutes = Math.floor((diff % 3600000) / 60000).toString().padStart(2, '0');
    var seconds = Math.floor((diff % 60000) / 1000).toString().padStart(2, '0');
    var timeString = hours + ':' + minutes + ':' + seconds;

    elements.forEach(function(el) { el.textContent = timeString; });
  }

  updateDailyCountdown();
  setInterval(updateDailyCountdown, 1000);
})();

// ============================================
// 2. COMPTE À REBOURS PAR PRODUIT
// ============================================
(function() {
  function parseEndDate(element) {
    var endAttr = element.getAttribute('data-end');
    if (endAttr && endAttr !== 'null' && endAttr !== '') {
      var date = new Date(endAttr);
      if (!isNaN(date.getTime())) return date;
    }
    var fallback = new Date();
    fallback.setHours(23, 59, 59, 999);
    return fallback;
  }

  function updateProductCountdowns() {
    var elements = document.querySelectorAll('[data-product-countdown]');
    if (elements.length === 0) return;

    elements.forEach(function(el) {
      var endDate = parseEndDate(el);
      var diff = Math.max(0, endDate - new Date());

      if (diff === 0) {
        el.textContent = 'Expiré';
        el.style.color = '#e53e3e';
        return;
      }

      var hours = Math.floor(diff / 3600000).toString().padStart(2, '0');
      var minutes = Math.floor((diff % 3600000) / 60000).toString().padStart(2, '0');
      var seconds = Math.floor((diff % 60000) / 1000).toString().padStart(2, '0');
      el.textContent = hours + ':' + minutes + ':' + seconds;
    });
  }

  updateProductCountdowns();
  setInterval(updateProductCountdowns, 1000);
})();

// ============================================
// 3. SÉLECTEUR DE QUANTITÉ PRODUIT
// ============================================
window.changeQuantity = function(change) {
  var input = document.getElementById('quantityInput');
  if (!input) return;
  var newValue = Math.max(1, (parseInt(input.value) || 1) + change);
  input.value = newValue;
};

// ============================================
// 4. MISE À JOUR DU COMPTEUR PANIER
// Écoute cart:updated dispatché par ux-enhancements et cart drawer
// ============================================
(function() {
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = '(' + cart.item_count + ')';
        });
      })
      .catch(function(err) { console.error('Cart count error:', err); });
  }

  updateCartCount();
  document.addEventListener('cart:updated', updateCartCount);
})();

// ============================================
// 5. BANNIÈRE STICKY PROMO (si activée dans settings)
// ============================================
(function() {
  var closeBtn = document.getElementById('closePromo');
  var stickyPromo = document.getElementById('stickyPromo');

  if (!closeBtn || !stickyPromo) return;

  if (sessionStorage.getItem('promoBannerClosed') === 'true') {
    stickyPromo.style.display = 'none';
    return;
  }

  closeBtn.addEventListener('click', function() {
    stickyPromo.classList.add('hidden');
    setTimeout(function() { stickyPromo.style.display = 'none'; }, 500);
    sessionStorage.setItem('promoBannerClosed', 'true');
  });
})();

// ============================================
// 6. LAZY LOADING FALLBACK (navigateurs anciens)
// Les navigateurs modernes gèrent loading="lazy" nativement
// ============================================
(function() {
  if ('loading' in HTMLImageElement.prototype) return;

  var imageObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var img = entry.target;
        if (img.dataset.src) img.src = img.dataset.src;
        observer.unobserve(img);
      }
    });
  });

  document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
    imageObserver.observe(img);
  });
})();

// ============================================
// 7. SMOOTH SCROLL POUR LES ANCRES
// ============================================
(function() {
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();